<template>
  <div>
    <div class="joinTypeContain">
      <div style="display: flex; justify-content: center;">
        <div class="flex  mobileFlex" style="gap: 10rem;">
          <div class="personJoin joinbtnSize">
            <div class="flex joinBox">
              <p class="fs26">개인회원</p>
              <div class="joinImgBox">
                <img
                  src="../../assets/images/user/개인회원아이콘Big.png"
                  alt="person join"
                />
              </div>
              <button @click="onClickType('USER')" class="usrJoinBtn">
                <strong>가입하기</strong>
              </button>
              <!--<button class="kakaoBtn" @click="KakaoLogin"></button>-->
            </div>
            <p>
              AgeTech Platform의 다양한 정보와<br />
              서비스를 모두 이용하실 수 있습니다.
            </p>
          </div>
          <div class="corpJoin joinbtnSize">
            <div class="flex joinBox">
              <p class="fs26">기업회원</p>
              <div class="joinImgBox addPd">
                <img
                  src="../../assets/images/user/기업회원아이콘.png"
                  alt="coperation join"
                />
              </div>
              <button @click="onClickType('CORP')" class="usrJoinBtn">
                <strong>가입하기</strong>
              </button>
            </div>
            <p>
              AgeTech Platform의 기업지원을 위한<br />
              서비스를 모두 이용하실 수 있습니다.
            </p>
          </div>
        </div>
      </div>

      <div class="mobileTxtColorR fs24 mt-5">
        <p>
          *회원 유형에 따라 가입 절차에 차이가 있으니 개인회원 또는 기업회원을
          선택해주세요.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters("join", ["getKakaoRedirectUri"]),
  },
  methods: {
    ...mapMutations("join", ["setCurrentTab", "setType"]),
    onClickType(type) {
      this.setType(type);
      this.setCurrentTab(1);
    },
    KakaoLogin() {
      this.setType("KAKAO");
      window.Kakao.Auth.authorize({
        redirectUri: this.getKakaoRedirectUri,
      });
    },
  },
};
</script>

<style scoped>
.mobileTxtColorR p {
  color: #9e1915;
}

.joinbtnSize {
  width: 290px;
  flex-shrink: 0;
}

.joinbtnSize .joinBox {
  width: 100%;
  height: 300px;
  padding: 10px;
  text-align: center;
  background: #fdfbfb;
  border: 1px solid #d7d8df;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;
}

.joinbtnSize button:active {
  transform: scale(0.95);
}

.joinbtnSize .joinBox p {
  line-height: 38px;
  color: #272727;
}

.joinbtnSize > p {
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 26px;
  text-align: center;
  color: #272727;
  padding: 2.4rem 1rem 1rem;
  margin: 0 0 20px 0;
}

.joinbtnSize .joinBox img {
  margin: 20px 0 24px;
}

.joinbtnSize .joinBox button {
  display: block;
  font-size: 2rem;
  line-height: 30px;
  color: #ffffff;
  width: 144px;
  background: #26336a;
  border-radius: 90px;
  padding: 4px 0 2px;
  margin: 0 auto 10px;
  outline: none;
  border: 0;
  cursor: pointer;
}

.joinbtnSize .joinBox .kakaoBtn {
  background: url("../../assets/images/Btn/카카오톡로그인버튼_sm.png");
  background-repeat: no-repeat;
  background-size: contain;
  height: 36px;
}

.joinImgBox.addPd {
  padding: 11px 0 0 0;
}

@media screen and (max-width: 560px) {
  .joinTypeContain {
    padding: 0;
  }

  .joinbtnSize {
    max-width: 290px;
  }
}
</style>
